import axios from "axios";

const authInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {"Content-Type": "application/json"},
  timeout: 1000 * 15,
  useToast: true,
});

const noAuthInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {"Content-type": "application/json"},
  timeout: 5000,
  useToast: true,
});

export {authInstance, noAuthInstance};
